import Backbone from 'common/vendor/backbone';
import debounce from 'debounce';

export interface HistoryListenerArguments {
  location: Location;
}

export interface ListenerFunc {
  (args: HistoryListenerArguments): void;
}

export const listeners = new Set<ListenerFunc>();

/**
 * After measuring several calls from rendered Views,
 * 25ms was the shortest amount I found we could afford
 * without potentially impacting UX.
 *
 * With this setting, the listeners are called
 * 3 times at most.
 */
const ROUTE_LISTENERS_DEBOUNCE_DELAY = 25;

export const triggerRouteListeners = debounce(() => {
  for (const listener of listeners) {
    listener({ location: Backbone.history.location });
  }
}, ROUTE_LISTENERS_DEBOUNCE_DELAY);



// WEBPACK FOOTER //
// ./app/common/components/route-context/listeners.ts